import React, { useState } from "react";
import ReactModal from "react-modal";
import { FormProvider } from "react-hook-form";
import { Input, DateInput, Draggable, FileList, FileUploadBox } from "@components";
import { SearchUserModal } from "@pages";
import { useBoardFormModal } from "@hooks";

function BoardFormModal({ 
  isOpen, 
  onClose, 
  onSuccess, 
  isEdit, 
  boardNum,
  maxFileCount = 1, // 단일 = 1 , 다중 = n
}) {
  const {
    handleFormSubmit:finalHandleFormSubmit,
    setValue,
    watch,
    reset,
    loadingDetail,
    detailError,
    markDelete,
    selectedFiles,
    setSelectedFiles,
    deletedFileSns,
    existingFilesCount,
    ...methods
  } = useBoardFormModal({ isOpen, isEdit, boardNum, onClose, onSuccess, maxFileCount });
  
  const atchFileId = watch("atchFileId");
  const position = Draggable({ isOpen, dragHandle: ".modal-header" });

  // 담당자 검색 모달 상태 관리
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const handleSearchConfirm = (selectedUser) => {
    // 선택한 담당자 정보를 react-hook-form에 반영
    setValue("writer", selectedUser.name);
    setSearchModalOpen(false);
  };

  const onError = (err) => {
    alert("필수 입력란을 확인하세요.");
  }

  const handleFormSubmit = methods.handleSubmit(finalHandleFormSubmit, onError);

  const containerStyle = {
    maxWidth: "1050px",
    minWidth: "1050px",
    maxHeight: isEdit ? "450px" : "410px",
    minHeight: isEdit ? "450px" : "410px",
    transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px)`
  };

  return (
    <>
      <ReactModal
        isOpen={isOpen}
        onRequestClose={onClose}
        overlayClassName="modal-overlay"
        className="modal-wrap"
      >
        <FormProvider {...methods}>
          <form onSubmit={handleFormSubmit}>
            <div className="modal-container" style={containerStyle}>
              <div className="modal-header" style={{ cursor: "move" }}>
                <h5>
                  테스트·게시판·글 <span className="modal-header-span">{isEdit ? "수정" : "등록"}</span>
                </h5>
                <button type="button" className="modal-btn-close" onClick={onClose}>
                  <span className="modal-btn-span">X</span>
                </button>
              </div>
              <div className="modal-content">
                {loadingDetail && isEdit ? (
                  <div>데이터 로딩 중...</div>
                ) : detailError ? (
                  <div>오류 발생: {detailError.message}</div>
                ) : (
                  <table className="table-write" style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <th>
                          테스트날짜 <span className="red">*</span>
                        </th>
                        <td>
                          <DateInput 
                            name="testDate"
                            rules={{ required:true }}
                          />
                        </td>
                        <th>담당자 <span className="red">*</span></th>
                        <td>
                          <div className="input-btn-wrap">
                            <Input
                              name="writer"
                              placeholder="담당자 선택하세요."
                              divStyle={{width:'calc(100% - 40px)'}}
                              rules={{ required:true }}
                              readOnly
                            />
                            <button
                              type="button"
                              onClick={() => setSearchModalOpen(true)}
                              className="search-icon"
                             />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>제목 <span className="red">*</span></th>
                        <td colSpan={3}>
                          <Input
                            name="title"
                            placeholder="제목을 입력하세요."
                            maxLength="50"
                            rules={{ required:true }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>테스트 내용</th>
                        <td colSpan={3}>
                          <Input
                            name="content"
                            placeholder="내용을 입력하세요."
                            maxLength="100"
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>첨부</th>
                        <td colSpan={3}>
                          {/* 수정 모드라면 기존 파일 목록을 보여준다 */}
                          {isEdit && atchFileId && (
                            <FileList
                              atchFileId={atchFileId}
                              showDelete={true}
                              className="edit"
                              deletedFileSns={deletedFileSns}
                              onFileDeleteMark={(file) => {
                                markDelete(file);
                              }}
                            />
                          )}

                          {/* 파일 업로드 부분 */}
                          <FileUploadBox
                            maxFileCount={maxFileCount}
                            selectedFiles={selectedFiles}
                            setSelectedFiles={setSelectedFiles}
                            existingFilesCount={existingFilesCount}
                            deletedFileSns={deletedFileSns}
                          />

                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
              <div className="modal-btn-wrap btn-right-box">
                <ul>
                  <li><button type="button" className="btn-cancel" onClick={onClose}>취소</button></li>
                  <li><button type="submit" className="btn-save">저장</button></li>
                </ul>
              </div>
            </div>
          </form>
        </FormProvider>
      </ReactModal>
      <SearchUserModal
        isOpen={searchModalOpen}
        onClose={() => setSearchModalOpen(false)}
        onConfirm={handleSearchConfirm}
      />
    </>
  );
}

export { BoardFormModal };
